import { createAction, props } from '@ngrx/store';
import { Employee } from 'src/app/model/employee';

export const loadEmployee = createAction(
  '[Employee] Load Employee'
);

export const loadEmployeeSuccess = createAction(
  '[Employee] Load Employee Success',
  props<{ loggedInemployee: Employee }>()
);

export const loadEmployeeFailure = createAction(
  '[Employee] Load Employee Failure',
  props<{ error: any }>()
);
